import { render } from "./trustee_landing.html?vue&type=template&id=70d2b653&scoped=true&external"
import script from "./trustee_landing.js?vue&type=script&lang=js&external"
export * from "./trustee_landing.js?vue&type=script&lang=js&external"

import "./TrusteeLanding.vue?vue&type=style&index=0&id=70d2b653&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d2b653"]])

export default __exports__